import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import {useExclusiveHover} from 'components/DSYS/useExclusiveHover';
import {useHoverShade} from 'components/DSYS/useHoverShade';

// "› Label (N)": the fold at the bottom of a box — Milestones' and metrics'
// Closed, Sub-workstreams' Archived, a card's More. Quiet (subtle label, faint
// count), darkening on hover. With `rowPadding` it spans the box like the rows
// around it and tints on hover as they do.
export const FoldToggle = ({
  label,
  count,
  open,
  onToggle,
  rowPadding,
}: {
  label: string;
  count?: number;
  open: boolean;
  onToggle: () => void;
  rowPadding?: string;
}) => {
  const {hovered, onMouseEnter, onMouseLeave} = useExclusiveHover();
  const spansRow = rowPadding !== undefined;
  const shade = useHoverShade(hovered && spansRow);
  return (
    <button
      type="button"
      aria-expanded={open}
      aria-label={count === undefined ? label : `${label} (${count})`}
      // Keeps an enclosing scan card from taking the hover (WorkstreamScanList).
      data-hovers-self
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      // Mouse clicks don't take focus, so the focus ring only shows for keyboard use.
      onMouseDown={(event) => event.preventDefault()}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${atoms({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: hovered ? 'Text Base' : 'Text Subtle',
      })} ${spansRow ? shade.className : ''}`}
      style={{
        ...(spansRow && shade.style),
        gap: 6,
        border: 0,
        padding: rowPadding ?? 0,
        background: 'none',
        ...(spansRow ? {width: '100%'} : {alignSelf: 'flex-start'}),
      }}
    >
      <UIIcon src={open ? ChevronDownLine : ChevronRightLine} size="small" />
      <Text size="small" isBold color={hovered ? 'standard' : 'subtle'}>
        {label}
      </Text>
      {count !== undefined && (
        <Text size="small" color="faint">
          ({count})
        </Text>
      )}
    </button>
  );
};
